<template>
  <div class="gradient-top">
    <NuxtImg
        src="img/gradient.png"
        alt="Gradient"
        width="800"
        height="337"
    />
  </div>
  <header class="sticky-top" :class="{'active': isScrolled}">
    <div class="container">
      <div class="row">
        <div class="col-12 col-xs-10 col-md-10 col-lg-8 mx-auto">
          <div class="row">
            <div class="col-12 d-flex align-items-center justify-content-end">
              <div class="d-flex my-2 align-items-center me-auto">
                <NuxtLink title="Promo Rewards deals" :to="isDutch ? '/nl' : '/'">
                  <NuxtImg
                      alt="Reminder for Flying Blue"
                      width="40"
                      height="40"
                      class="rounded-3 my-1"
                      src="img/logo-small.webp"
                  />
                </NuxtLink>
              </div>
              <div class="d-flex align-items-center border-end ps-3 pe-3" role="button">
                <LazySearch>
                  <i class="fa-solid fa-magnifying-glass text-primary-darken position-relative me-2"></i>
                  <span v-if="$device.isMobile" class="title fw-bold">{{ isDutch ? "Zoeken" : "Search" }}</span>
                  <span v-else class="title fw-bold">{{ isDutch ? "Zoek vliegticket" : "Find your ticket" }}</span>
                </LazySearch>
              </div>
              <div class="btn-group ms-3">
                <button class="btn btn-sm d-flex align-items-center dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-user text-primary-darken me-2"></i>
                  {{ authStore.name }}
                  <span class="title fw-bold">
                    <span v-if="!authStore.isLoading && authStore.user && authStore.user.name">
                      {{ authStore.user.name }}
                    </span>
                    <span v-else-if="!authStore.isLoading && authStore.user">
                      {{ isDutch ? "Mijn account" : "My Account" }}
                    </span>
                    <span v-else>
                      Account
                    </span>
                  </span>
                </button>
                <ul class="dropdown-menu">
                  <li v-if="!authStore.user">
                    <span @click="showLoginModal = true" role="button" title="Log Out" class="dropdown-item">
                      {{ isDutch ? "Inloggen" : "Sign In" }}
                    </span>
                  </li>
                  <li v-if="!authStore.user">
                    <span @click="showRegisterModal = true" role="button" title="Log Out" class="dropdown-item">
                      {{ isDutch ? "Maak account" : "Create Account" }}
                    </span>
                  </li>
                  <li>
                    <span v-if="authStore.user" @click="logOut" role="button" title="Log Out" class="dropdown-item">
                      {{ isDutch ? "Uitloggen" : "Log Out" }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="btn-group ms-2">
                <button class="btn btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <NuxtImg
                      width="20"
                      height="13"
                      loading="lazy"
                      type="svg"
                      :alt="(isDutch ? 'Nederlandse vlag' : 'US flag')"
                      :src="(isDutch ? 'img/nl-flag.svg' : 'img/us-flag.svg')"
                  />
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <span role="button" title="Switch to English" :class="{'active': !isDutch}" class="dropdown-item" @click="getAlternateUrl('en')">English</span>
                  </li>
                  <li>
                    <span role="button" title="Verander naar Nederlands" :class="{'active': isDutch}" class="dropdown-item" @click="getAlternateUrl('nl')">Nederlands</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <LazyLoginModal v-if="!authStore.user" :show="showLoginModal" @update-show="showLoginModal = $event" />
  <LazyRegisterModal v-if="!authStore.user" :show="showRegisterModal" @update-show="showRegisterModal = $event"/>
</template>

<script setup>
import Search from "~/components/Search.vue";
import { useAuthStore } from "~/store/auth";

const isDutch = inject('isDutch')

const authStore = useAuthStore();

let getAlternateUrl = (lang) => {
  let linkElement = document.querySelector('link[hreflang="' + lang + '"]');
  window.open(linkElement ? linkElement.getAttribute('href') : (isDutch ? '/' : '/nl'), '_self');
}

const isScrolled = ref(false)
const showLoginModal = ref(false);
const showRegisterModal = ref(false);

async function logOut() {
  authStore.logout()
}

onMounted(() => {

  const checkScroll = () => {
    isScrolled.value = window.scrollY > 50
  }

  window.addEventListener('scroll', checkScroll)
})

onUnmounted(() => {
  const checkScroll = () => {
    isScrolled.value = window.scrollY > 50
  }
  window.removeEventListener('scroll', checkScroll)
})

</script>
